import {
  HasPermissionGuardActions,
  IsAlreadyLoggedInGuardActions,
  IsLoggedInGuardActions,
  JwtTokenActions,
  LoginFormActions,
  UserEffectActions,
} from '@elio/emanager-front/auth/action';
import { User } from '@elio/emanager-front/auth/model';
import { MessagingSubscriptionActions } from '@elio/emanager-front/push-messaging/action';
import { SimpleEntityCallState } from '@elio/shared/models';
import { localStorageGet, sessionStorageGet } from '@elio/shared/utils';
import { Action, createReducer, on } from '@ngrx/store';

export const USER_KEY = 'user';

export interface UserState extends SimpleEntityCallState {
  user: User | null;
  jwtAccessToken: string | null;
  remenberMe: boolean;
  isLoggedIn: boolean;
}

const initialState: UserState = {
  user: null,
  jwtAccessToken: null,
  isLoggedIn: false,
  remenberMe: false,
  callState: 'INIT',
};

const reducer = createReducer(
  initialState,
  on(
    UserEffectActions.loadUserSuccess,
    UserEffectActions.updateUserSuccess,
    (state, action): UserState => ({
      ...state,
      user: action.user,
      isLoggedIn: true,
      callState: 'LOADED',
    })
  ),
  on(
    LoginFormActions.loginSuccess,
    (state, action): UserState => ({
      ...state,
      user: action.user,
      remenberMe: action.rememberMe,
      jwtAccessToken: action.jwtAccessToken,
      isLoggedIn: true,
      callState: 'LOADED',
    })
  ),
  on(
    HasPermissionGuardActions.loadUser,
    IsLoggedInGuardActions.loadUser,
    IsAlreadyLoggedInGuardActions.loadUser,
    (state): UserState =>
      state.isLoggedIn
        ? state
        : {
            ...state,
            callState: 'LOADING',
            remenberMe: !!localStorageGet<string>('jwtAccessToken'),
            jwtAccessToken: localStorageGet<string>('jwtAccessToken') ?? sessionStorageGet<string>('jwtAccessToken'),
          }
  ),
  on(UserEffectActions.userIsAlreadyLoaded, (state): UserState => ({ ...state, callState: 'LOADED' })),
  on(
    JwtTokenActions.refreshJwtTokenSuccess,
    (state, action): UserState => ({
      ...state,
      jwtAccessToken: action.jwtAccessToken,
    })
  ),
  on(
    UserEffectActions.loadUserFailure,
    UserEffectActions.loadUserFailureNoRedirection,
    JwtTokenActions.refreshJwtTokenFailure,
    (state, action): UserState => ({
      ...state,
      ...initialState,
      callState: { error: action.error },
    })
  ),
  on(
    MessagingSubscriptionActions.successAndLogout,
    MessagingSubscriptionActions.failureAndLogout,
    (): UserState => initialState
  )
);

export function authReducer(state: UserState | undefined, action: Action) {
  return reducer(state, action);
}
